import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type { DeleteLiveChatMessageArgs } from "../types"

/** Roles a teammate may take back: their own replies and the agent's. */
export const RETRACTABLE_LIVE_CHAT_ROLES = ["AGENT", "AI"] as const

export const liveChatMessageMutators = {
	delete: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: DeleteLiveChatMessageArgs
			ctx: ZeroJwtPayload
		}) => {
			const message = await tx.query.liveChatMessages
				.where("id", "=", args.id)
				.related("session")
				.one()
				.run()
			if (!message || message.session?.workspaceId !== authData.workspaceId) {
				throw new Error("Live chat message not found")
			}
			if (
				!(RETRACTABLE_LIVE_CHAT_ROLES as readonly string[]).includes(
					message.role,
				)
			) {
				throw new Error("Only teammate and agent messages can be deleted")
			}
			if (message.isDeleted) return

			await tx.mutate.liveChatMessages.update({
				id: args.id,
				isDeleted: true,
				updatedAt: Date.now(),
				version: message.version + 1,
			})
		},
	),
}
